import { Link } from '@material-ui/core';
import { ONBOARDING_ERRORS } from 'common/constants/constants';
import { ErrorBox } from 'components/InfoBox';
import { Inline } from 'components/base/Text';
import { StyledOnboardingErrorWrapper } from './OnboardingError.style';

/**
 * Onboarding error message
 * @param {object} props
 * @param {string} props.error
 * @param {() => void} props.onInviteAdminClick
 * @returns {JSX.Element}
 */
export const GitProviderSelectError = ({ error, onInviteAdminClick }) => {
  return (
    <StyledOnboardingErrorWrapper>
      <ErrorBox>
        {error === ONBOARDING_ERRORS.NO_ORGANIZATIONS && (
          <Inline>
            Authentication failed. Your account is not associated with any
            organizations.{' '}
            <Link onClick={onInviteAdminClick}>
              Not the admin? Invite your admin &gt;
            </Link>
          </Inline>
        )}
      </ErrorBox>
    </StyledOnboardingErrorWrapper>
  );
};
